import L from 'leaflet';

const iconeNormal = new L.Icon({
    iconUrl: require('./iconeNormal.png'),
    iconRetinaUrl: require('./iconeNormal.png'),
    iconAnchor: [15, 42],
    iconSize: new L.Point(30, 40),
});
const iconeNormalAtivo = new L.Icon({
    iconUrl: require('./iconeNormal.png'),
    iconRetinaUrl: require('./iconeNormal.png'),
    iconAnchor: [20, 50],
    iconSize: new L.Point(40, 50),
});
const iconeSimples = new L.Icon({
    iconUrl: require('./markerSimples.png'),
    iconRetinaUrl: require('./markerSimples.png'),
    iconAnchor: [20, 30],
    iconSize: new L.Point(15, 25),
});
export { iconeNormal, iconeNormalAtivo, iconeSimples };